/* 公共引入,勿随意修改,修改时需经过确认 */
import "normalize.css";
import "animate.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./aos";
import "./iview";
import "./component";
import "./cosee";

import VConsole from "vconsole";
const VUE_APP_ENV = process.env.VUE_APP_ENV;
if ("staging".includes(VUE_APP_ENV)) {
  new VConsole();
}

// 调用埋点
if ("production".includes(VUE_APP_ENV)) {
  console.log("调用埋点=>production");
  gtag("config", "G-3P3LW9JPTS");
} else if ("staging".includes(VUE_APP_ENV)) {
  console.log("调用埋点=>staging");
  gtag("config", "G-8EB5RPGLVM");
}
